const { getCookie, hasCookie } = require("cookies-next");

export function getUserDetails(router = []) {
    try {
        if (hasCookie("userDetails")) {
            const cookies = getCookie("userDetails");
            if (cookies && typeof cookies === "string") {
                return JSON.parse(cookies);
            } else {
                router.push("/login");
                return {};
            }
        } else {
            router.push("/login");
            return {};
        }
    } catch (error) {
        console.error("Error parsing user details cookie:", error);
        router.push("/login");
        return {};
    }
}
